import { render, staticRenderFns } from "./bates.vue?vue&type=template&id=94dc1960&"
import script from "./bates.vue?vue&type=script&lang=js&"
export * from "./bates.vue?vue&type=script&lang=js&"
import style0 from "./bates.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports